import { NgModule, LOCALE_ID }     from '@angular/core';
import { BrowserModule }           from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { HttpClient, HttpClientModule } from '@angular/common/http';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';

import { CoreModule } from 'src/app/core/core.module';
import { SharedModule } from 'src/app/shared/shared.module';
import { TemplateModule } from './template/template.module';

import { ApprobationsModule } from './modules/approbations/approbations.module';
import { AuthenticationModule } from './modules/authentication/authentication.module';
import { ClassesModule } from './modules/classes/classes.module';
import { DiscountsModule } from './modules/discounts/discounts.module';
import { EditionsModule } from './modules/editions/editions.module';
import { EnrollmentsModule } from './modules/enrollments/enrollments.module';
import { GendersModule } from './modules/genders/genders.module';
import { KnownsModule } from './modules/knowns/knowns.module';
import { StudentsModule } from './modules/students/students.module';
import { TutorsModule } from './modules/tutors/tutors.module';

// Locale data
import { registerLocaleData } from '@angular/common';
import localeES from '@angular/common/locales/es';

registerLocaleData(localeES);

export function HttpLoaderFactory (http: HttpClient) {
    return new TranslateHttpLoader(http);
}

@NgModule({

    declarations: [
        AppComponent
    ],

    imports: [

        BrowserModule,
        BrowserAnimationsModule,
        AppRoutingModule,

        CoreModule,
        SharedModule,
        TemplateModule,

        ApprobationsModule,
        AuthenticationModule,
        ClassesModule,
        DiscountsModule,
        EditionsModule,
        EnrollmentsModule,
        GendersModule,
        KnownsModule,
        StudentsModule,
        TutorsModule,

        TranslateModule.forRoot({
            defaultLanguage: 'es',
            loader: {
                provide: TranslateLoader,
                useFactory: HttpLoaderFactory,
                deps: [ HttpClient ]
            },
        }),

        HttpClientModule

    ],

    providers: [
        {
            provide: LOCALE_ID,
            useValue: 'es-ES'
        }
    ],

    bootstrap: [
        AppComponent
    ]

})
export class AppModule { }
